module.exports = __webpack_public_path__ + "static/media/QueenslandAust.295d05da.png";